import { ReportsPage } from './pages';

export const reportsRoutes = [
  {
    path: 'reports',
    component: ReportsPage,
    requiredPermission: 'reports.view',
  },
];
